// Settings → Debug → "Dynamic reports" (docs/capsules/dynamic-report.md): a per-browser
// preference, off by default, that has the report modal offer its Standard | Dynamic switch.
import { usePersistedState } from "../../hooks/usePersistedState.js";
import { DYNAMIC_REPORT_PREF_KEY } from "../../lib/report/dynamicReportOffer.js";

/**
 * @param {{debugUI: boolean, dynamicReportEnabled: boolean}} deps `debugUI`: the effective debug
 *   UI (toggle ANDed with the server's gate); `dynamicReportEnabled`: /api/me's answer, which is
 *   the routes' own gate
 * @returns {{dynamicReportPref: boolean, setDynamicReportPref: Function, dynamicReportOn: boolean}}
 *   `dynamicReportOn` is the preference where it can take effect: debug UI on and the routes on
 */
export function useDynamicReport({ debugUI, dynamicReportEnabled }) {
  const [dynamicReportPref, setDynamicReportPref] = usePersistedState(
    DYNAMIC_REPORT_PREF_KEY,
    false,
  );
  return {
    dynamicReportPref,
    setDynamicReportPref,
    dynamicReportOn: !!(dynamicReportPref && debugUI && dynamicReportEnabled),
  };
}
